import { render } from "./SearchFormViewer.vue?vue&type=template&id=212a9f8f&ts=true"
import script from "./SearchFormViewer.vue?vue&type=script&lang=ts"
export * from "./SearchFormViewer.vue?vue&type=script&lang=ts"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__